import React from 'react';
import {Button, Col, Label, Row} from 'reactstrap';
import {AvGroup} from 'availity-reactstrap-validation';
import PropTypes from 'prop-types';
import AvField from "../../shared/component/form/AvField";
import Translate from "../../shared/language/Translate";
import {Fieldset} from "primereact/fieldset";

import GeneralUtils from "../../shared/utils/GeneralUtils";
import {
    BARCODE_LENGTH,
    BARCODE_TYPE,
    PRODUCT_UNIT,
    TILL_PRICE_CALCULATION_METHOD,
    TILL_PRICE_ITEM_CALCULATION_METHOD,
    VAT_RATES
} from "../../shared/utils/Constants";
import {InputNumber} from "primereact/inputnumber";
import {Checkbox} from "primereact/checkbox";
import DepartmentService from "../../shared/service/DepartmentService";
import TaxService from "../../shared/service/TaxService";
import {toast} from "react-toastify";
import ProductService from "../../shared/service/ProductService";
import SupplierService from "../../shared/service/SupplierService";
import NumberFormat from 'react-number-format';
import StockActivityService from "../../shared/service/StockActivityService";
import {AutoComplete} from "primereact/autocomplete";
import MerchantBranchSettingsService from "../../shared/service/MerchantBranchSettingsService";
import {SplitButton} from 'primereact/splitbutton';
import MerchantUserService from "../../shared/service/MerchantUserService";
import PurchaseOrderService from "../../shared/service/PurchaseOrderService";
import PurchaseOrderItemConflictDialog, {
    CONFLICT_SELECT_NONE
} from "../../shared/component/dialog/PurchaseOrderItemConflictDialog";


const defaultProduct = {
    id: '',
    name: '',
    status: 'ACTIVE',
    barcode: '',
    minStock: null,
    maxStock: null,
    currentStock: null,
    stockOperation: '',
    oldPrice: null,
    stockOperationReason: '',
    barcodeType: "NORMAL",
    barcodeDigit: null,
    codeLength: null

};

export default class PurchaseOrderItemMobileSave extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            product: Object.assign({}, defaultProduct),
            productDetailsSaveButtonRender: true,
            disabledFields: false,
            taxList: [],
            departmentList: [],
            isOpenFromItem: true,
            displayShowStatusConfirmDialog: false,
            currentStock: null,
            displaySplitButton: true,
            supplierList: [],
            purchaseOrderStatus: false,
            filteredProducts: [],
            tillPriceCalculationMethod: "",
            splitKey: 1,
            productOpen: true,
            costPricingOpen: false,
            othersOpen: false,
            printQueueTillUserBssId: null,
            tillUserList: [],
            showConflictDialog: false,
            conflictingItems: [],
            conflictMessage: "",
            pendingSaveAction: null,
            pendingSaveType: null
        }
        this.departmentService = new DepartmentService();
        this.taxService = new TaxService();
        this.productService = new ProductService();
        this.supplierService = new SupplierService();
        this.stockActivityService = new StockActivityService();
        this.merchantBranchSettingsService = new MerchantBranchSettingsService();
        this.merchantUserService = new MerchantUserService();
        this.purchaseOrderService = new PurchaseOrderService();
    }

    componentDidMount() {
        this.taxService.findAll().then(response => this.setState({taxList: response}));
        this.departmentService.findAll().then(response => this.setState({departmentList: response}));
        this.supplierService.findAll().then(response => this.setState({supplierList: response}));
        this.merchantUserService.getTillUsers(localStorage.getItem("merchantBranchId")).then(response => {
            if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                this.setState({
                    tillUserList: response,
                });
            }

        });


    }

    setDisplaySplitButton = (displaySplitButton) => {
        this.setState({
            displaySplitButton: displaySplitButton,
        });
    }
    setData = (data, purchaseOrderStatus, invoiceType, isOpenFromItem, tillPriceCalculationMethod, printQueueTillUserBssId) => {
        let product = Object.assign({}, data);
        if (product.itemBssId != null) {
            this.stockActivityService.getCurrentStockOfProduct(product.itemBssId)
                .then((response) => {
                    if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                        this.setState({
                            currentStock: response,
                        });
                    } else {
                        this.setState({
                            currentStock: null,
                        });
                    }
                });
        } else {
            this.setState({
                currentStock: null,
            });
        }

        this.setState({
            productOpen: true,
            costPricingOpen: false,
            othersOpen: false
        });

        let productDetailsSaveButtonRender = true;
        if (purchaseOrderStatus == "CLOSED") {
            productDetailsSaveButtonRender = false;
        } else if (purchaseOrderStatus == "PARTIAL_CLOSED" && product.itemClosed) {
            productDetailsSaveButtonRender = false;
        }
        if (product.status == "PASSIVE") {
            productDetailsSaveButtonRender = false;
        }


        this.setState({
            product: product,
            printQueueTillUserBssId: printQueueTillUserBssId,
            tillPriceCalculationMethod: tillPriceCalculationMethod,
            invoiceType: invoiceType,
            purchaseOrderStatus: purchaseOrderStatus,
            isOpenFromItem: isOpenFromItem,
            productDetailsSaveButtonRender: productDetailsSaveButtonRender,
            disabledFields: purchaseOrderStatus === "CLOSED" || (purchaseOrderStatus === "PARTIAL_CLOSED" && product.itemClosed) || product.status == "PASSIVE",
        }, () => {
            this.focusBarcodeInput();
            product = this.props.calculateFields(product);
            this.setState({product: product});
        });

    }

    focusBarcodeInput = () => {
        try {
            setTimeout(() => {
                try {
                    let input = null;

                    // Hangi barcode input focus olacak?
                    if (
                        this.state.invoiceType === "MANUAL_ENTRY" &&
                        !this.state.disabledFields &&
                        this.barcodeRef1
                    ) {
                        input = this.barcodeRef1;
                    } else if (
                        (this.state.invoiceType === "UPLOAD" || this.state.invoiceType === "CSV") &&
                        !this.state.disabledFields &&
                        !this.state.product.newCodedProduct &&
                        this.barcodeRef2
                    ) {
                        input = this.barcodeRef2;
                    }

                    if (input) {
                        // Focus ver
                        input.focus();

                        // Caret’i sona taşı (küçük micro-delay ile)
                        setTimeout(() => {
                            try {
                                const len = input.value?.length || 0;
                                input.setSelectionRange(len, len);
                            } catch (innerErr) {
                                console.error("Caret positioning error:", innerErr);
                            }
                        }, 10);
                    }
                } catch (err) {
                    console.error("Barcode focus error:", err);
                }
            }, 200); // render + DOM update + repaint için güvenli gecikme
        } catch (outerErr) {
            console.error("Unexpected error in focusBarcodeInput:", outerErr);
        }
    };


    render() {
        return (
            <div
                className="p-col-12 mobile-page-content"
                onClick={(e) => {
                    if (this.splitRef?.state?.overlayVisible) {
                        this.splitRef.hide();
                    }
                }}
            >
                <PurchaseOrderItemConflictDialog
                    show={this.state.showConflictDialog}
                    conflictingItems={this.state.conflictingItems}
                    message={this.state.conflictMessage}
                    onSaveClick={this.handleConflictResolution}
                    onCancelClick={this.handleConflictCancel}
                />
                {this.renderProductDetails()}

                {this.renderPriceCalculator()}

                {this.renderOthers()}

                {this.renderButtons()}
            </div>
        );
    }


    renderOthers() {
        return (
            <>
                <Fieldset
                    legend="More"
                    toggleable
                    collapsed={!this.state.othersOpen}
                    onToggle={this.toggleOthers}
                >
                    <Row>
                        <Col md="3">

                            <AvGroup>
                                <Label for="mobilePhone">
                                    <Translate contentKey="contactManagement.mobilePhone">Invoice Till User
                                    </Translate>
                                </Label>

                                <AvField
                                    type="select"
                                    disabled={true}
                                    className="form-control"
                                    name="printQueueTillUserBssId"
                                    value={this.state.printQueueTillUserBssId}
                                    onChange={this.__handleChange}>

                                    <option value="" key=''>
                                        Select
                                    </option>
                                    {this.state.tillUserList.map(element => (
                                        <option value={element.bssId} key={element.bssId}>
                                            {element.name}
                                        </option>))}
                                </AvField>

                            </AvGroup>
                        </Col>


                        <Col md="3">

                            <AvGroup>
                                <Label for="mobilePhone">
                                    <Translate contentKey="contactManagement.mobilePhone">Item Till User
                                    </Translate>
                                </Label>

                                <AvField
                                    type="select"
                                    disabled={this.state.disabledFields}
                                    className="form-control"
                                    name="printQueueTillUserBssId"
                                    value={this.state.product.printQueueTillUserBssId}
                                    onChange={this.__handleChange}>

                                    <option value="" key=''>
                                        Select
                                    </option>
                                    {this.state.tillUserList.map(element => (
                                        <option value={element.bssId} key={element.bssId}>
                                            {element.name}
                                        </option>))}
                                </AvField>

                            </AvGroup>
                        </Col>

                        {!GeneralUtils.isNullOrEmpty(this.state.product.orjDescription) &&
                            <Col md="4">
                                <AvGroup>
                                    <Label for="barcode">
                                        <Translate contentKey="purchaseOrderItem.barcode">Original
                                            Description</Translate>
                                    </Label>
                                    <AvField
                                        type="text"
                                        name="orjDescription"
                                        disabled={true}
                                        className="form-control"
                                        value={this.state.product.orjDescription}
                                        onKeyDown={this._handleKeyDown}
                                        onChange={this.__handleChange}
                                    />
                                </AvGroup>
                            </Col>
                        }


                        {(this.state.invoiceType == "UPLOAD" || this.state.invoiceType == "CSV") &&
                            <Col md="2">
                                <AvGroup>
                                    <Label for="barcode">
                                        <Translate contentKey="purchaseOrderItem.barcode">Product Code</Translate>
                                    </Label>
                                    <AvField
                                        type="text"
                                        name="productCode"
                                        disabled={GeneralUtils.isNullOrEmpty(this.state.product.id) ? false : true}
                                        className="form-control"
                                        value={this.state.product.productCode}
                                        onKeyDown={this._handleKeyDown}
                                        onChange={this.__handleChange}
                                    />
                                </AvGroup>
                            </Col>
                        }
                        <Col md="3">
                        {this.renderBarcodeFields()}
                        </Col>

                        <Col md="3">
                            <AvGroup>
                                <Label for="boxPrice">
                                    <Translate contentKey="producttradingName">Cur. Box Cost</Translate>
                                </Label>
                                <NumberFormat
                                    value={this.state.product.currentBoxPrice}
                                    className="number-format-input"
                                    thousandSeparator={true}
                                    decimalScale={2}
                                    fixedDecimalScale={true}
                                    prefix={'£'}
                                    onValueChange={(values) => {
                                        this.__handleChange({
                                            target: {name: "currentBoxPrice", value: values.value}
                                        });
                                    }}
                                    disabled={true}
                                />
                            </AvGroup>
                        </Col>

                        <Col md="3">
                            <AvGroup>
                                <Label for="boxPrice">
                                    <Translate contentKey="producttradingName">Cur. Unit Cost</Translate>
                                </Label>
                                <NumberFormat
                                    value={this.state.product.currentUnitCost}
                                    className="number-format-input"
                                    thousandSeparator={true}
                                    decimalScale={2}
                                    fixedDecimalScale={true}
                                    prefix={'£'}
                                    onValueChange={(values) => {
                                        this.__handleChange({
                                            target: {name: "currentUnitCost", value: values.value}
                                        });
                                    }}
                                    disabled={true}
                                />
                            </AvGroup>
                        </Col>


                        <Col md="3">
                            <AvGroup>
                                <Label for="actualMargin">
                                    <Translate contentKey="location.cityId">Unit Profit</Translate>
                                </Label>
                                <NumberFormat
                                    value={this.state.product.profit}
                                    className="number-format-input"
                                    thousandSeparator={true}
                                    decimalScale={2}
                                    fixedDecimalScale={true}
                                    prefix={'£'}
                                    onValueChange={(values) => {
                                        this.__handleChange({
                                            target: {name: "profit", value: values.value}
                                        });
                                    }}
                                    disabled={true}
                                />
                            </AvGroup>
                        </Col>

                        <Col md="3">
                            <AvGroup>
                                <Label for="totalProfit">
                                    <Translate contentKey="product.totalProfit">Total Profit</Translate>
                                </Label>
                                <NumberFormat
                                    value={
                                        (this.state.product.profit || 0) *
                                        (this.state.product.deliveryQuantity || 0) *
                                        (this.state.product.boxSize || 0)
                                    }
                                    className="number-format-input"
                                    thousandSeparator={true}
                                    decimalScale={2}
                                    fixedDecimalScale={true}
                                    prefix={'£'}
                                    disabled={true}
                                />
                            </AvGroup>
                        </Col>


                    </Row>
                </Fieldset>
            </>
        );
    }

    renderProductDetails() {
        const safeParse = (val) => {
            if (val === null || val === undefined || val === '') {
                return 0;
            }
            return parseFloat(val);
        };
        const sale = safeParse(this.state.product.salePrice);
        const old = safeParse(this.state.product.oldPrice);

        const showArrow =
            sale != null &&
            old != null &&
            old !== 0 &&
            sale.toFixed(2) !== old.toFixed(2);

        const isDown = showArrow && sale < old; // indirim
        const isUp = showArrow && sale > old; // zam


        return (
            <>
                <Fieldset legend="Product"

                          toggleable
                          collapsed={!this.state.productOpen}
                          onToggle={this.toggleProduct}

                >
                    <Row>
                        {this.state.invoiceType == "MANUAL_ENTRY" &&
                            <Col xs="12" md="3">
                                <AvGroup>
                                    <Label
                                        for="barcode"
                                        style={{display: 'flex', alignItems: 'center', gap: '4px'}}
                                    >
                                        <span>
                                            <Translate contentKey="purchaseOrderItem.barcode">Barcode</Translate>
                                            <span style={{color: 'red'}}> (*)</span>
                                        </span>
                                        {this.renderStatusBadge()}
                                    </Label>
                                    <div style={{display: 'flex', alignItems: 'stretch', width: '100%', boxSizing: 'border-box', flexWrap: 'nowrap', gap: '2px', minWidth: 0}}>
                                        <div style={{flex: 1, minWidth: 0}}>
                                            <AvField
                                                type="text"
                                                name="barcode"
                                                innerRef={(el) => (this.barcodeRef1 = el)}
                                                disabled={this.state.disabledFields || this.state.invoiceType == "MANUAL_ENTRY"}
                                                className="form-control"
                                                style={{width: '100%', boxSizing: 'border-box'}}
                                                value={this.state.product.barcode}
                                                onKeyDown={this._handleKeyDown}
                                                onChange={this.__handleChange}
                                            />
                                        </div>
                                        <Button
                                            type="button"
                                            color="link"
                                            disabled={this.state.disabledFields || this.state.invoiceType == "MANUAL_ENTRY"}
                                            style={{
                                                flexShrink: 0,
                                                width: '28px',
                                                minWidth: '28px',
                                                padding: '4px',
                                                border: 'none',
                                                background: 'transparent',
                                                boxShadow: 'none',
                                                marginTop: 0,
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center'
                                            }}
                                            onClick={this.handleBarcodeSearchClick}
                                            title="Restore Item"
                                        >
                                            <i className="pi pi-search" style={{fontSize: '0.8rem'}}/>
                                        </Button>
                                    </div>
                                </AvGroup>
                            </Col>
                        }

                        {(this.state.invoiceType == "UPLOAD" || this.state.invoiceType == "CSV") &&
                            <Col xs="12" md="3">
                                <AvGroup>
                                    <Label
                                        for="barcode"
                                        style={{display: 'flex', alignItems: 'center', gap: '4px'}}
                                    >
                                        <span>
                                            <Translate contentKey="purchaseOrderItem.barcode">Barcode</Translate>
                                            <span style={{color: 'red'}}> (*)</span>
                                        </span>
                                        {this.renderStatusBadge()}
                                    </Label>
                                    <div style={{display: 'flex', alignItems: 'stretch', width: '100%', boxSizing: 'border-box', flexWrap: 'nowrap', gap: '2px', minWidth: 0}}>
                                        <div style={{flex: 1, minWidth: 0}}>
                                            <AvField
                                                type="text"
                                                name="barcode"
                                                innerRef={(el) => (this.barcodeRef2 = el)}
                                                disabled={this.state.disabledFields || this.state.product.newCodedProduct}
                                                className="form-control"
                                                style={{width: '100%', boxSizing: 'border-box'}}
                                                value={this.state.product.barcode}
                                                onKeyDown={this._handleKeyDown}
                                                onChange={this.__handleChange}
                                            />
                                        </div>
                                        <Button
                                            type="button"
                                            color="link"
                                            disabled={this.state.disabledFields || this.state.product.newCodedProduct}
                                            style={{
                                                flexShrink: 0,
                                                width: '28px',
                                                minWidth: '28px',
                                                padding: '4px',
                                                border: 'none',
                                                background: 'transparent',
                                                boxShadow: 'none',
                                                marginTop: 0,
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center'
                                            }}
                                            onClick={this.handleBarcodeSearchClick}
                                            title="Restore Item"
                                        >
                                            <i className="pi pi-search" style={{fontSize: '0.8rem'}}/>
                                        </Button>
                                    </div>
                                </AvGroup>
                            </Col>
                        }


                        {/** Item Name */}
                        <Col md="4">
                            <AvGroup>
                                <Label for="itemName">
                                    <Translate contentKey="purchaseOrderItem.itemName">Name</Translate>
                                    <span style={{color: 'red'}}> (*)</span>
                                </Label>


                                <AutoComplete value={this.state.product.itemName}
                                              suggestions={
                                                  this.state.filteredProducts
                                              }
                                              dropdown={(() => {
                                                  const barcode = this.state.product.barcode?.toString() || "";
                                                  return !barcode || barcode.length < 8;
                                              })()}

                                              onFocus={(e) => {
                                                  const query = this.state.product.itemName || "";
                                                  this.searchProduct({query});
                                              }}
                                              onBlur={() => {
                                                  setTimeout(() => {
                                                      this.setState({filteredProducts: []});
                                                  }, 500);
                                              }}
                                              completeMethod={this.searchProduct}
                                              itemTemplate={(item) => {
                                                  if (item.id === -1) {
                                                      return (
                                                          <span style={{color: "red", fontWeight: "bold"}}>
                                                            <i className="pi pi-plus-circle"
                                                               style={{marginRight: "5px"}}/>
                                                              {item.longname}
                                                        </span>
                                                      );
                                                  }
                                                  return <span>{item.longname}</span>;
                                              }}
                                              name="itemName"
                                              field="longname"
                                              disabled={this.state.disabledFields || this.state.invoiceType == "MANUAL_ENTRY" || this.state.invoiceType == "CSV"}
                                              onChange={(e) => {
                                                  let value = e.target.parsedValue !== undefined ? e.target.parsedValue : e.target.value;
                                                  let product = this.state.product;

                                                  this.setState({product: product});
                                                  if (!GeneralUtils.isNullOrEmpty(e.value?.id)) {
                                                      if (e.value?.id == -1) {
                                                          let product = this.state.product;
                                                          product["barcodeIsSearched"] = true;
                                                          product["newCodedProduct"] = true;
                                                          product["itemBssId"] = null;
                                                          product["oldPrice"] = null;
                                                          product["currentBoxPrice"] = null;
                                                          product["currentUnitCost"] = null;
                                                          product["status"] = "ACTIVE";
                                                          this.setState({
                                                              product: product,
                                                              currentStock: null
                                                          });
                                                          this.generateNextBarcode();
                                                          this.getDefaultData();
                                                      } else {
                                                          let product = this.state.product;
                                                          product["itemName"] = value;
                                                          this.setState({product: product});
                                                          this.convertToDto(e.value);
                                                      }

                                                  } else {
                                                      product["itemName"] = value;
                                                      this.setState({product});
                                                  }
                                              }}


                                />


                            </AvGroup>
                        </Col>

                        {/** Item Size */}
                        <Col md="2">
                            <AvGroup>
                                <Label for="itemSize">
                                    <Translate contentKey="purchaseOrderItem.itemSize">Item Size</Translate>
                                    <span style={{color: 'red'}}> (*)</span>
                                </Label>
                                <AvField
                                    type="number"
                                    name="itemSize"
                                    disabled={this.state.disabledFields || this.state.invoiceType == "MANUAL_ENTRY"}
                                    className="form-control"
                                    value={this.state.product.itemSize}
                                    onChange={this.__handleChange}
                                />
                            </AvGroup>
                        </Col>

                        {/** Item Unit Measure */}
                        <Col md="2">
                            <AvGroup>
                                <Label for="itemUnitMeasure">
                                    <Translate contentKey="purchaseOrderItem.itemUnitMeasure">Item Unit</Translate>
                                    <span style={{color: 'red'}}> (*)</span>
                                </Label>

                                <AvField
                                    type="select"
                                    className="form-control"
                                    name="itemUnitMeasure"
                                    disabled={this.state.disabledFields || this.state.invoiceType == "MANUAL_ENTRY"}
                                    value={this.state.product.itemUnitMeasure}
                                    onChange={this.__handleChange}>
                                    {PRODUCT_UNIT.map(element => (
                                        <option value={element.value} key={element.value}>
                                            {element.name}
                                        </option>))}
                                </AvField>

                            </AvGroup>
                        </Col>
                    </Row>

                    <Row>


                    </Row>

                    <Row>
                        <Col md="3">
                            <AvGroup>
                                <Label for="mobilePhone">
                                    <Translate contentKey="contactManagement.mobilePhone">Department</Translate>
                                    <span style={{color: 'red'}}> (*)</span>
                                </Label>
                                <AvField
                                    type="select"
                                    value={this.state.product.departmentId}
                                    disabled={this.state.disabledFields}
                                    className="form-control"
                                    name="departmentId"
                                    onChange={this.__handleChange}
                                >
                                    <option value='' key=''/>
                                    {this.state.departmentList.map(element => (
                                        <option value={element.id} key={element.id}>
                                            {element.name}
                                        </option>
                                    ))}
                                </AvField>
                            </AvGroup>
                        </Col>


                        {/** Tax Rate */}
                        <Col md="3">
                            <AvGroup>
                                <Label for="taxRate">
                                    <Translate contentKey="purchaseOrderItem.taxRate">Vat</Translate>
                                    <span style={{color: 'red'}}> (*)</span>
                                </Label>
                                <AvField
                                    type="select"
                                    name="taxRate"
                                    disabled={this.state.disabledFields}
                                    className="form-control"
                                    value={this.state.product.taxRate}
                                    onChange={this.__handleChange}
                                >
                                    <option value='' key=''/>
                                    {VAT_RATES.map(element => (
                                        <option value={element.value} key={element.value}>
                                            {element.name}
                                        </option>
                                    ))}
                                </AvField>
                            </AvGroup>
                        </Col>


                        <Col md="3">
                            <AvGroup>
                                <Label for="salePrice">
                                    <Translate contentKey="purchaseOrderItem.salePrice">Sale Price</Translate>
                                    {showArrow && (
                                        <span
                                            style={{
                                                marginLeft: '6px',
                                                marginRight: '2px',
                                                color: isDown ? '#e81123' : '#2EB85C',
                                                fontWeight: 'bold'
                                            }}
                                        >
            {isDown ? '▼' : '▲'}</span>
                                    )}
                                    <span style={{color: 'red'}}> (*)</span>
                                </Label>
                                <NumberFormat
                                    value={this.state.product.salePrice}
                                    className="number-format-input"
                                    thousandSeparator={true}
                                    decimalScale={2}
                                    fixedDecimalScale={true}
                                    prefix={'£'}
                                    onValueChange={(values) => {
                                        // isManual flag'i yalnızca kullanıcı inputu sırasında set edilecek
                                        this.__handleChangePrice({
                                            target: {name: "salePrice", value: values.value},
                                            isManual: this.userTyping  // sadece klavyeden girişse true
                                        });
                                    }}
                                    onKeyDown={() => {
                                        this.userTyping = true;
                                    }}
                                    onBlur={() => {
                                        this.userTyping = false;
                                    }} // inputtan çıkınca sıfırla

                                    disabled={this.state.disabledFields}
                                />
                            </AvGroup>
                        </Col>


                        <Col md="3">
                            <AvGroup>
                                <Label for="deliveryQuantity">
                                    <Translate contentKey="purchaseOrderItem.deliveryQuantity">Delivery
                                        Qty</Translate>
                                    <span style={{color: 'red'}}> (*)</span>
                                </Label>
                                <AvField
                                    type="number"
                                    name="deliveryQuantity"
                                    disabled={this.state.disabledFields}
                                    className="form-control"
                                    value={this.state.product.deliveryQuantity}
                                    onChange={this.__handleChange}
                                />
                            </AvGroup>
                        </Col>


                        <Col md="3">
                            <AvGroup>
                                <Label for="boxSize">
                                    <Translate contentKey="location.cityId">Box Qty</Translate>
                                    <span style={{color: 'red'}}> (*)</span>
                                </Label>
                                <AvField
                                    type="number"
                                    name="boxSize"
                                    disabled={this.state.disabledFields}
                                    className="form-control"
                                    value={this.state.product.boxSize}
                                    onChange={this.__handleChange}
                                />
                            </AvGroup>
                        </Col>


                        <Col md="3">
                            <AvGroup>
                                <Label for="tradingName">
                                    <Translate contentKey="producttradingName">New Stock</Translate>
                                </Label>
                                <InputNumber
                                    name="newStock"
                                    disabled={true}
                                    value={
                                        ((this.state.product.deliveryQuantity || 0) * (this.state.product.boxSize || 0))
                                    }
                                    className="w-100"
                                />
                            </AvGroup>
                        </Col>
                        <Col md="3">
                            <AvGroup>
                                <Label for="tradingName">
                                    <Translate contentKey="producttradingName">Current Stock</Translate>
                                </Label>
                                <InputNumber
                                    name="currentStock"
                                    disabled={true}
                                    value={this.state.currentStock}
                                    className="w-100"
                                />
                            </AvGroup>
                        </Col>
                        <Col md="3">
                            <AvGroup>
                                <Label for="tradingName">
                                    <Translate contentKey="producttradingName">Min Stock</Translate>
                                </Label>
                                <InputNumber
                                    name="minStock"
                                    disabled={this.state.disabledFields}
                                    value={this.state.product.minStock}
                                    onChange={this.__handleChange}
                                    className="w-100"
                                />
                            </AvGroup>
                        </Col>

                        <Col md="3">
                            <AvGroup>
                                <Label for="tradingName">
                                    <Translate contentKey="producttradingName">Max Stock</Translate>
                                </Label>
                                <InputNumber
                                    name="maxStock"
                                    disabled={this.state.disabledFields}
                                    value={this.state.product.maxStock}
                                    onChange={this.__handleChange}
                                    className="w-100"
                                />
                            </AvGroup>
                        </Col>


                    </Row>

                </Fieldset>


            </>
        );
    }

    renderBarcodeFields() {
        const {product, disabledFields} = this.state;
        const barcodeLength = product.barcode?.toString().length ?? 0;

        // Eğer 12 veya daha fazla karakter varsa Barcode Type ve Code Length göster
        if (barcodeLength >= 12) {
            return (
                <div style={{display: 'flex', gap: 10}}>
                    <div style={{flex: 1}}>
                        <AvGroup>
                            <Label>
                                <Translate contentKey="producttradingName">Barcode Type</Translate>
                            </Label>
                            <AvField
                                type="select"
                                className="form-control"
                                name="barcodeType"
                                disabled={disabledFields}
                                value={product.barcodeType}
                                onChange={this.__handleChange}
                            >
                                {BARCODE_TYPE.map(el => (
                                    <option value={el.value} key={el.value}>{el.name}</option>
                                ))}
                            </AvField>
                        </AvGroup>
                    </div>

                    {(product.barcodeType === "PRICE" || product.barcodeType === "WEIGHT") && (
                        <div style={{flex: 1}}>
                            <AvGroup>
                                <Label>
                                    <Translate contentKey="producttradingName">Code Length</Translate>
                                </Label>
                                <AvField
                                    type="select"
                                    className="form-control"
                                    name="codeLength"
                                    disabled={disabledFields}
                                    value={product.codeLength}
                                    onChange={this.__handleChange}
                                >
                                    <option value=""/>
                                    {BARCODE_LENGTH.map(el => (
                                        <option value={el.value} key={el.value}>{el.name}</option>
                                    ))}
                                </AvField>
                            </AvGroup>
                        </div>
                    )}
                </div>
            );
        }

        // Eğer 1-4 karakter varsa Weighable checkbox göster
        if (barcodeLength > 0 && barcodeLength < 5) {
            return (
                <div style={{display: 'flex', gap: 10}}>
                    <div style={{flex: 1}}>
                        <AvGroup>
                            <Label>
                                <Translate contentKey="productfirstName">Weighable</Translate>
                            </Label>
                            <Checkbox
                                onChange={(e) => this.setChecked("weighable", e.checked)}
                                name="weighable"
                                disabled={disabledFields}
                                value={product.weighable}
                                checked={product.weighable}
                            />
                        </AvGroup>
                    </div>
                </div>
            );
        }

        return null;
    }

    renderPriceCalculator() {
        return (
            <>
                <Fieldset legend="Price Calculator"

                          toggleable
                          collapsed={!this.state.costPricingOpen}
                          onToggle={this.toggleCostPricing}
                >

                    <Row>
                        <Col md="3">
                            <AvGroup>
                                <Label for="firstName">
                                    <Translate contentKey="productfirstName">Invoice Price Calculator
                                    </Translate>
                                </Label>

                                <AvField
                                    type="select"
                                    className="form-control"
                                    name="tillPriceCalculationMethod"
                                    disabled={true}
                                    value={this.state.tillPriceCalculationMethod}
                                >
                                    {TILL_PRICE_CALCULATION_METHOD.map(element => (
                                        <option value={element.value} key={element.value}>
                                            {element.name}
                                        </option>))}
                                </AvField>


                            </AvGroup>
                        </Col>

                        <Col md="3">
                            <AvGroup>
                                <Label for="firstName">
                                    <Translate contentKey="productfirstName">Item Price Calculator
                                    </Translate>
                                </Label>

                                <AvField
                                    type="select"
                                    className="form-control"
                                    name="tillPriceCalculationMethod"
                                    disabled={this.state.disabledFields}
                                    value={this.state.product.tillPriceCalculationMethod}
                                    onChange={this.__handleChange}>
                                    <option value="" key=''>
                                        Select
                                    </option>
                                    {TILL_PRICE_ITEM_CALCULATION_METHOD.map(element => (
                                        <option value={element.value} key={element.value}>
                                            {element.name}
                                        </option>))}
                                </AvField>


                            </AvGroup>
                        </Col>

                        {/* Unit Cost */}
                        <Col md="3">
                            <AvGroup>
                                <Label for="unitCost">
                                    <Translate contentKey="producttradingName">Unit Cost</Translate>
                                </Label>
                                <NumberFormat
                                    value={this.state.product.unitCost}
                                    className="number-format-input"
                                    thousandSeparator={true}
                                    decimalScale={2}
                                    fixedDecimalScale={true}
                                    prefix={'£'}
                                    onValueChange={(values) => {
                                        this.__handleChange({
                                            target: {name: "unitCost", value: values.value}
                                        });
                                    }}
                                    disabled={true}
                                />
                            </AvGroup>
                        </Col>
                        <Col md="3">
                            <AvGroup>
                                <Label for="taxRate">
                                    <Translate contentKey="purchaseOrderItem.taxRate">Vat</Translate>
                                    <span style={{color: 'red'}}> (*)</span>
                                </Label>
                                <AvField
                                    type="select"
                                    name="taxRate"
                                    disabled={this.state.disabledFields}
                                    className="form-control"
                                    value={this.state.product.taxRate}
                                    onChange={this.__handleChange}
                                >
                                    <option value='' key=''/>
                                    {VAT_RATES.map(element => (
                                        <option value={element.value} key={element.value}>
                                            {element.name}
                                        </option>
                                    ))}
                                </AvField>
                            </AvGroup>
                        </Col>
                        <Col md="3">
                            <AvGroup>
                                <Label for="profitMargin">
                                    <Translate contentKey="location.cityId">Profit Margin</Translate>
                                    <span style={{color: 'red'}}> (*)</span>
                                </Label>
                                <AvField
                                    type="number"
                                    name="profitMargin"
                                    step="1"
                                    onKeyDown={(e) => [".", ",", "e", "E", "+", "-"].includes(e.key) && e.preventDefault()}
                                    disabled={this.state.disabledFields}
                                    className="form-control"
                                    value={this.state.product.profitMargin}
                                    onChange={this.__handleChange}
                                />
                            </AvGroup>
                        </Col>
                        {/* Recommended Sale Price */}
                        <Col md="3">
                            <AvGroup>
                                <Label for="recommendedSalePrice">
                                    <Translate contentKey="producttradingName">Rec. Price</Translate>
                                </Label>
                                <NumberFormat
                                    value={this.state.product.recommendedSalePrice}
                                    className="number-format-input"
                                    thousandSeparator={true}
                                    decimalScale={2}
                                    fixedDecimalScale={true}
                                    prefix={'£'}
                                    onValueChange={(values) => {
                                        this.__handleChange({
                                            target: {name: "recommendedSalePrice", value: values.value}
                                        });
                                    }}
                                    disabled={true}
                                />
                            </AvGroup>
                        </Col>
                        <Col md="3">
                            <AvGroup>
                                <Label for="salePrice">
                                    <Translate contentKey="purchaseOrderItem.salePrice">Sale Price</Translate>
                                    <span style={{color: 'red'}}> (*)</span>
                                </Label>
                                <NumberFormat
                                    value={this.state.product.salePrice}
                                    className="number-format-input"
                                    thousandSeparator={true}
                                    decimalScale={2}
                                    fixedDecimalScale={true}
                                    prefix={'£'}
                                    onValueChange={(values) => {
                                        // isManual flag'i yalnızca kullanıcı inputu sırasında set edilecek
                                        this.__handleChangePrice({
                                            target: {name: "salePrice", value: values.value},
                                            isManual: this.userTyping  // sadece klavyeden girişse true
                                        });
                                    }}
                                    onKeyDown={() => {
                                        this.userTyping = true;
                                    }}
                                    onBlur={() => {
                                        this.userTyping = false;
                                    }} // inputtan çıkınca sıfırla

                                    disabled={this.state.disabledFields}
                                />
                            </AvGroup>
                        </Col>
                        <Col md="3">
                            <AvGroup>
                                <Label for="totalPrice">
                                    <Translate contentKey="purchaseOrderItem.totalPrice">Cur. Price</Translate>
                                </Label>
                                <InputNumber
                                    name="oldPrice"
                                    disabled={true}
                                    value={this.state.product.oldPrice}
                                    onChange={this.__handleChange}
                                    mode="currency"
                                    className="w-100"
                                    currency="GBP"
                                    locale="en-US"
                                />

                            </AvGroup>
                        </Col>
                        <Col md="3">
                            <AvGroup>
                                <Label for="actualMargin">
                                    <Translate contentKey="location.cityId">Actual Margin</Translate>
                                </Label>
                                <AvField
                                    type="number"
                                    name="actualMargin"
                                    disabled={true}
                                    className="form-control"
                                    value={this.state.product.actualMargin}
                                    onChange={this.__handleChange}
                                />
                            </AvGroup>
                        </Col>
                        <Col md="3">
                            <AvGroup>
                                <Label for="boxPrice">
                                    <Translate contentKey="producttradingName">Box Cost</Translate>
                                </Label>
                                <NumberFormat
                                    value={this.state.product.boxPrice}
                                    className="number-format-input"
                                    thousandSeparator={true}
                                    decimalScale={2}
                                    fixedDecimalScale={true}
                                    prefix={'£'}
                                    onValueChange={(values) => {
                                        this.__handleChange({
                                            target: {name: "boxPrice", value: values.value}
                                        });
                                    }}
                                    disabled={true}
                                />
                            </AvGroup>
                        </Col>


                        <Col md="3">
                            <AvGroup>
                                <Label for="totalPrice">
                                    <Translate contentKey="purchaseOrderItem.totalPrice">Total Cost</Translate>
                                    <span style={{color: 'red'}}> (*)</span>
                                </Label>
                                <NumberFormat
                                    value={this.state.product.totalPrice}
                                    className="number-format-input"
                                    thousandSeparator={true}
                                    decimalScale={2}
                                    fixedDecimalScale={true}
                                    prefix={'£'}
                                    onValueChange={(values) => {
                                        this.__handleChange({
                                            target: {name: "totalPrice", value: values.value}
                                        });
                                    }}
                                    disabled={this.state.disabledFields}
                                />
                            </AvGroup>
                        </Col>
                    </Row>


                </Fieldset>
            </>
        );
    }


    renderStatusBadge() {
        const product = this.state?.product;
        if (!product) {
            return null;
        }

        const badgeStyle = {
            padding: "1px 4px",
            borderRadius: "4px",
            fontWeight: 600,
            fontSize: "10px",
        };
        const iconStyle = { color: "white", fontSize: "10px" };

        // PASSIVE -> kırmızı IGNORE rozeti
        if (product.status === "PASSIVE") {
            return (
                <span style={{ ...badgeStyle, backgroundColor: "#DC2626", color: "white" }}>
                    {GeneralUtils.isMobile() ? "I" : "IGNR"}
                </span>
            );
        }

        // Barkod sorgulanmamışsa -> kırmızı uyarı ikonu
        if (product.barcodeIsSearched === false) {
            return (
                <span
                    className="blinking-badge"
                    style={{
                        display: "inline-flex",
                        alignItems: "center",
                        gap: "2px",
                        ...badgeStyle,
                        backgroundColor: "#DC2626",
                        color: "white",
                    }}
                >
                    <i className="pi pi-exclamation-triangle" style={iconStyle}/>
                </span>
            );
        }

        // Ürün henüz sisteme kayıtlı değilse -> mavi NEW rozeti
        if (!product.itemBssId) {
            return (
                <span className="blinking-badge" style={{ ...badgeStyle, backgroundColor: "#1D4ED8", color: "white" }}>
                    {GeneralUtils.isMobile() ? "N" : "NEW"}
                </span>
            );
        }

        // Kayıtlı ve sorun yoksa -> yeşil onay ikonu
        return (
            <span
                style={{
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "2px",
                    ...badgeStyle,
                    backgroundColor: "#16A34A",
                    color: "white",
                }}
            >
                <i className="pi pi-check" style={{ cursor: "pointer", ...iconStyle }}/>
            </span>
        );
    }


    renderButtons() {
        const actions = [];

        // Save
        if (this.state.productDetailsSaveButtonRender) {
            actions.push({
                label: 'Save',
                command: () => {
                    this.updateOrderItem("save");
                    this.setState({splitKey: this.state.splitKey + 1});
                }
            });
        }

        // Ignore
        if (this.state.productDetailsSaveButtonRender &&
            this.state.product.status === "ACTIVE") {

            actions.push({
                label: 'Ignore',
                command: () => {
                    const obj1 = {...this.state.product, status: "PASSIVE"};
                    this.state.isOpenFromItem
                        ? this.props.updatePurchaseOrderItemAndNext(obj1)
                        : this.props.updatePurchaseOrderItemAndNextUnmatched(obj1);

                    this.setState({splitKey: this.state.splitKey + 1});
                }
            });
        }

        // Reset Item
        if (this.state.productDetailsSaveButtonRender &&
            this.state.invoiceType === "UPLOAD" &&
            this.state.product.barcodeIsSearched &&
            !GeneralUtils.isNullOrEmpty(this.state.product.orjDescription)) {

            actions.push({
                label: 'Reset Item',
                command: () => {
                    const product = {...this.state.product};
                    product.barcode = null;
                    product.barcodeIsSearched = false;
                    product.itemBssId = null;
                    product.itemName = product.orjDescription || "";
                    const obj1 = {...product};
                    this.state.isOpenFromItem
                        ? this.props.updatePurchaseOrderItemAndNext(obj1)
                        : this.props.updatePurchaseOrderItemAndNextUnmatched(obj1);
                    this.setState({product, splitKey: this.state.splitKey + 1});
                }
            });
        }

        // Unignore
        if (this.state.purchaseOrderStatus !== "CLOSED" &&
            this.state.purchaseOrderStatus !== "PARTIAL_CLOSED" &&
            this.state.product.status === "PASSIVE") {

            actions.push({
                label: 'Unignore',
                command: () => {
                    const obj1 = {...this.state.product, status: "ACTIVE"};
                    this.state.isOpenFromItem
                        ? this.props.updatePurchaseOrderItemAndNext(obj1)
                        : this.props.updatePurchaseOrderItemAndNextUnmatched(obj1);

                    this.setState({splitKey: this.state.splitKey + 1});
                }
            });
        }

        // Restore Item
        if (this.state.productDetailsSaveButtonRender &&
            this.state.invoiceType === "UPLOAD" &&
            this.state.product.barcodeIsSearched &&
            !GeneralUtils.isNullOrEmpty(this.state.product.itemBssId)) {

            actions.push({
                label: 'Restore Item',
                command: () => {
                    let product = {...this.state.product};
                    product["barcodeIsSearched"] = false;
                    this.setState({product}, () => this.findByBarcode());

                    this.setState({splitKey: this.state.splitKey + 1});
                }
            });
        }


        return (
            <div className="mobile-fixed-footer">
                <div className="mobile-fixed-footer-inner">

                    {this.state.displaySplitButton &&
                        <SplitButton
                            ref={(elem) => this.splitRef = elem}
                            key={this.state.splitKey}
                            label="Save & Next"
                            style={{height: '30px', lineHeight: '30px'}}
                            onClick={(e) => {
                                e.stopPropagation();
                                this.updateOrderItem("saveandnext");
                                this.setState({splitKey: this.state.splitKey + 1});
                            }}
                            model={actions}
                        />
                    }

                    {this.state.displaySplitButton === false &&
                        <Button
                            color="outline-primary"
                            style={{height: '30px', lineHeight: '30px'}}
                            onClick={(e) => {
                                this.savePurchaseOrderItem();
                                this.setState({splitKey: this.state.splitKey + 1});
                            }}
                        >
                            <Translate contentKey="entity.action.add">Save</Translate>
                        </Button>
                    }

                    <div style={{marginLeft: 'auto'}}>
                        <Button
                            color="outline-primary"
                            style={{height: '30px', lineHeight: '30px', marginRight: '5px'}}
                            onClick={() => {
                                const obj1 = {...this.state.product};
                                this.props.openNextItem(obj1);
                            }}
                        >
                            <Translate contentKey="entity.action.add">Next</Translate>
                        </Button>
                        <Button
                            color="outline-primary"
                            style={{height: '30px', lineHeight: '30px'}}
                            onClick={() => this.props.closeDisplayDialog()}
                        >
                            <Translate contentKey="entity.action.add">Back</Translate>
                        </Button>
                    </div>

                </div>
            </div>
        );
    }


    checkConflictsAndUpdate = (obj1, saveType) => {
        if (GeneralUtils.isNullOrEmpty(obj1?.id) || GeneralUtils.isNullOrEmpty(obj1?.productCode)) {
            this.executeUpdate(obj1, saveType);
            return;
        }
        this.purchaseOrderService.checkConflicts(obj1).then(response => {
            if (!GeneralUtils.isNullOrEmpty(response) && !GeneralUtils.isNullOrEmpty(response.type)) {
                // Error occurred, proceed with normal update
                this.executeUpdate(obj1, saveType);
                return;
            }

            if (response && response.hasConflict && response.conflictingItems && response.conflictingItems.length > 0) {
                // Conflicts found, show dialog
                this.setState({
                    showConflictDialog: true,
                    conflictingItems: response.conflictingItems,
                    conflictMessage: response.message || "These items conflict with the same barcode but different product codes. Please select one to keep.",
                    pendingSaveAction: obj1,
                    pendingSaveType: saveType
                });
            } else {
                // No conflicts, proceed with normal update
                this.executeUpdate(obj1, saveType);
            }
        }).catch(error => {
            // Error checking conflicts, proceed with normal update
            console.error("Error checking conflicts:", error);
            this.executeUpdate(obj1, saveType);
        });
    };

    executeUpdate = (obj1, saveType) => {
        if (saveType === "save") {
            this.props.updatePurchaseOrderItem(obj1);
        } else if (this.state.isOpenFromItem) {
            this.props.updatePurchaseOrderItemAndNext(obj1);
        } else {
            this.props.updatePurchaseOrderItemAndNextUnmatched(obj1);
        }
    };

    handleConflictResolution = (selectedItemId) => {
        const { pendingSaveAction, pendingSaveType } = this.state;
        
        if (!pendingSaveAction) {
            this.setState({ showConflictDialog: false });
            return;
        }

        // Resolve conflict and update (pass 0 to API when user chose "None" for backend compatibility)
        const apiSelectedId = selectedItemId === CONFLICT_SELECT_NONE ? 0 : selectedItemId;
        this.purchaseOrderService.resolveConflictAndUpdate(pendingSaveAction, apiSelectedId)
            .then(response => {
                if (!GeneralUtils.isNullOrEmpty(response) && !GeneralUtils.isNullOrEmpty(response.type)) {
                    toast.error("Error resolving conflict");
                    this.setState({ showConflictDialog: false });
                    return;
                }

                this.setState({ showConflictDialog: false });
                if (selectedItemId === CONFLICT_SELECT_NONE) {
                    if (this.props.refreshOrderAndClose) this.props.refreshOrderAndClose();
                    else this.executeUpdate(pendingSaveAction, pendingSaveType);
                } else if (selectedItemId == pendingSaveAction.id) {
                    this.executeUpdate(pendingSaveAction, pendingSaveType);
                } else {
                    if (this.props.refreshOrderAndClose) this.props.refreshOrderAndClose();
                    else this.executeUpdate(pendingSaveAction, pendingSaveType);
                }
            })
            .catch(error => {
                console.error("Error resolving conflict:", error);
                toast.error("Error resolving conflict");
                this.setState({ showConflictDialog: false });
            });
    };

    handleConflictCancel = () => {
        this.setState({
            showConflictDialog: false,
            conflictingItems: [],
            conflictMessage: "",
            pendingSaveAction: null,
            pendingSaveType: null
        });
    };

    /** Used when opened in Android WebView: back button should close conflict dialog first, then item dialog. */
    hasOpenConflictDialog = () => Boolean(this.state.showConflictDialog);
    closeConflictDialog = () => this.handleConflictCancel();

    savePurchaseOrderItem() {
        if (GeneralUtils.isNullOrEmpty(this.state.product.itemName)) {
            return toast.warn("Please fill the Item name field");
        } else if (GeneralUtils.isNullOrEmpty(this.state.product.barcode)) {
            return toast.warn("Please fill the Barcode field");
        } else if (GeneralUtils.isNullOrEmpty(this.state.product.deliveryQuantity)) {
            return toast.warn("Please fill the Delivery Qty field");
        } else if (this.state.product.totalPrice === null || this.state.product.totalPrice === undefined || this.state.product.totalPrice === '') {
            return toast.warn("Please fill the Total Cost field");
        } else if (GeneralUtils.isNullOrEmpty(this.state.product.salePrice)) {
            return toast.warn("Please fill the Sale Price field");
        } else if (GeneralUtils.isNullOrEmpty(this.state.product.departmentId)) {
            return toast.warn("Please select department");
        } else if (this.state.product.taxRate == null) {
            return toast.warn("Please fill the Tax Rate field");
        } else if (this.state.product.barcode != null && !GeneralUtils.isNullOrEmpty(this.state.product.barcodeType) && this.state.product.barcodeType != "NORMAL" && this.state.product.barcode.length >= 12 && GeneralUtils.isNullOrEmpty(this.state.product.codeLength)) {
            return toast.warn("Please fill the Code Length");
        } else {

            if (this.state.product.itemBssId == null && this.state.product.barcodeIsSearched && this.state.product.newCodedProduct) {
                this.saveProduct().then(() => {
                    let product = this.state.product;
                    let obj1 = {...product};
                    this.checkConflictsAndUpdate(obj1, "save");
                });
            } else {
                let product = this.state.product;
                let obj1 = {...product};
                this.checkConflictsAndUpdate(obj1, "save");
            }


        }

    }


    setChecked = (name, value) => {
        let product = this.state.product;
        product[name] = value;
        this.setState({product: product});
    }

    updateOrderItem = (save) => {
        if (this.state.invoiceType == "MANUAL_ENTRY" || this.state.invoiceType == "CSV") {
            if (GeneralUtils.isNullOrEmpty(this.state.product.deliveryQuantity)) {
                return toast.warn("Please fill the Delivery Qty field");
            } else if (this.state.product.totalPrice === null || this.state.product.totalPrice === undefined || this.state.product.totalPrice === '') {
                return toast.warn("Please fill the Total Price field");
            } else if (GeneralUtils.isNullOrEmpty(this.state.product.salePrice)) {
                return toast.warn("Please fill the Sale Price field");
            } else if (this.state.product.barcode != null && !GeneralUtils.isNullOrEmpty(this.state.product.barcodeType) && this.state.product.barcodeType != "NORMAL" && this.state.product.barcode.length >= 12 && GeneralUtils.isNullOrEmpty(this.state.product.codeLength)) {
                return toast.warn("Please fill the Code Length");
            } else {
                let product = this.state.product;
                let obj1 = {...product};
                this.checkConflictsAndUpdate(obj1, save);
            }
        } else {
            if (this.state.invoiceType == "UPLOAD") {
                if (GeneralUtils.isNullOrEmpty(this.state.product.itemName)) {
                    return toast.warn("Please fill the Item name field");
                } else if (GeneralUtils.isNullOrEmpty(this.state.product.barcode)) {
                    return toast.warn("Please fill the Barcode field");
                } else if (GeneralUtils.isNullOrEmpty(this.state.product.deliveryQuantity)) {
                    return toast.warn("Please fill the Delivery Qty field");
                } else if (this.state.product.totalPrice === null || this.state.product.totalPrice === undefined || this.state.product.totalPrice === '') {
                    return toast.warn("Please fill the Total Cost field");
                } else if (GeneralUtils.isNullOrEmpty(this.state.product.salePrice)) {
                    return toast.warn("Please fill the Sale Price field");
                } else if (GeneralUtils.isNullOrEmpty(this.state.product.departmentId)) {
                    return toast.warn("Please select department");
                } else if (this.state.product.taxRate == null) {
                    return toast.warn("Please fill the Tax Rate field");
                } else if (this.state.product.barcode != null && !GeneralUtils.isNullOrEmpty(this.state.product.barcodeType) && this.state.product.barcodeType != "NORMAL" && this.state.product.barcode.length >= 12 && GeneralUtils.isNullOrEmpty(this.state.product.codeLength)) {
                    return toast.warn("Please fill the Code Length");
                } else {

                    if (this.state.product.itemBssId == null && this.state.product.barcodeIsSearched && this.state.product.newCodedProduct) {
                        this.saveProduct().then(() => {
                            let product = this.state.product;
                            let obj1 = {...product};
                            this.checkConflictsAndUpdate(obj1, save);
                        });
                    } else {
                        let product = this.state.product;
                        let obj1 = {...product};
                        this.checkConflictsAndUpdate(obj1, save);
                    }
                }


            }

        }


    }

    _handleKeyDown = (e) => {
        if (e.target.name === 'barcode') {
            const allowedKeys = ['Backspace', 'Tab', 'Delete', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End', 'Enter'];
            const isDigit = e.key.length === 1 && /[0-9]/.test(e.key);
            const isAllowedSpecial = allowedKeys.includes(e.key);
            const isShortcut = e.ctrlKey || e.metaKey;
            if (!isDigit && !isAllowedSpecial && !isShortcut) {
                e.preventDefault();
                return;
            }
        }
        if (e.key === 'Enter') {
            this.findByBarcode();
        }
    }

    searchProduct = (event) => {
        const barcode = this.state.product.barcode?.toString() || "";

        const query = (event.query && event.query.trim() !== "")
            ? event.query
            : (this.state.product.itemName || "");


        if (!barcode || barcode.length < 8) {
            setTimeout(() => {
                this.productService.searchCodedProductsByName(query).then(response => {

                    if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                        this.setState({
                            filteredProducts: [
                                {id: -1, longname: "New Product"},
                                ...response
                            ]
                        });
                    } else {
                        this.setState(
                            {
                                filteredProducts: [
                                    {id: -1, longname: "New Product"}
                                ]
                            },
                            () => {
                            }
                        );
                    }
                });
            }, 100);
        } else {
            this.setState({filteredProducts: []});
        }
    };


    findByBarcode() {
        let product = this.state.product;
        if (product.barcodeIsSearched && !GeneralUtils.isNullOrEmpty(product.itemBssId)) {
            return toast.warn("Please use the Restore Item button to query again.");
        } else {
            if (!GeneralUtils.isNullOrEmpty(product.barcode)) {
                product["barcodeIsSearched"] = true;
                this.productService.findProductByBarcodeWithDepos(product.barcode)
                    .then(async (response) => {
                        if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                            this.refreshDepartmentListIfMissing(response.departmentId);
                            product["itemName"] = response.name;
                            product["itemBssId"] = response.bssId;
                            product["oldPrice"] = response.price;
                            product["currentBoxPrice"] = response.costPrice;
                            product["currentBoxSize"] = (response.boxQuantity != null && response.boxQuantity !== 0) ? response.boxQuantity : null;
                            product["status"] = "ACTIVE";
                            product["barcodeType"] = response.barcodeType;
                            product["barcodeDigit"] = response.barcodeDigit;
                            product["codeLength"] = response.codeLength;
                            product["profitMargin"] = response.profitMargin != null && response.profitMargin !== 0 && response.profitMargin !== 40
                                ? response.profitMargin
                                : (response.departmentProfitMargin != null && response.departmentProfitMargin !== 0 && response.departmentProfitMargin !== 40
                                    ? response.departmentProfitMargin
                                    : await this.getDefaultProfitMargin());

                            product["departmentId"] = response.departmentId;
                            product["taxRate"] = (response.taxRate ?? response.departmentTaxRate);
                            if (
                                GeneralUtils.isNullOrEmpty(product.id) ||
                                (
                                    !GeneralUtils.isNullOrEmpty(product.itemUnitMeasure) &&
                                    !GeneralUtils.isNullOrEmpty(product.itemSize) &&
                                    response.unit !== "each" &&
                                    response.quantity !== 1
                                )
                            ) {
                                product["itemUnitMeasure"] = response.unit;
                                product["itemSize"] = response.quantity;
                            }
                            if (response.minStock != null && response.minStock !== 0) {
                                product["minStock"] = response.minStock;
                            } else {
                                product["minStock"] = await this.getDefaultMinStock();
                            }

                            product["weighable"] = response.weighable;
                            if (response.boxQuantity != null && response.boxQuantity !== 0 && response.boxQuantity !== 1) {
                                product["boxSize"] = response.boxQuantity;
                            } else if (product["boxSize"] == null && response.boxQuantity != null) {
                                product["boxSize"] = response.boxQuantity;
                            }


                            product["boxPrice"] = response.boxPrice;
                            product["newCodedProduct"] = false;

                            if (response.maxStock != null && response.maxStock !== 0) {
                                product["maxStock"] = response.maxStock;
                                product["maxOrjStock"] = response.maxStock;
                            } else {
                                const deliveryQuantity = product.deliveryQuantity || 0;
                                const boxSize = product.boxSize || 0;
                                product["maxStock"] = deliveryQuantity * boxSize;
                                product["maxOrjStock"] = null;
                            }

                            const calculated = this.props.calculateFields?.(product) ?? product;
                            this.setState({product: calculated});
                            this.props.updatePurchaseOrderItemFieldsOnly?.(calculated);

                            this.stockActivityService.getCurrentStockOfProduct(response.bssId)
                                .then((response) => {
                                    if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                                        this.setState({
                                            currentStock: response,

                                        });
                                    }
                                });

                        } else {
                            product["itemBssId"] = null;
                            product["oldPrice"] = null;
                            product["currentBoxPrice"] = null;
                            product["currentBoxSize"] = null;
                            product["status"] = "ACTIVE";
                            product["profitMargin"] = await this.getDefaultProfitMargin();
                            product["barcodeIsSearched"] = true;
                            product["newCodedProduct"] = false;
                            product["barcodeType"] = "NORMAL";
                            product["barcodeDigit"] = null;
                            product["codeLength"] = null;
                            this.setState({
                                product: product,
                                currentStock: null
                            }, () => {
                                this.getDefaultData();
                            });

                            //return toast.warn("Barcode not Found!");
                        }
                    });
            }
        }


    }

    refreshDepartmentListIfMissing = (departmentId) => {
        if (GeneralUtils.isNullOrEmpty(departmentId)) {
            return;
        }
        const exists = (this.state.departmentList || []).some((department) => department.id === departmentId);
        if (!exists) {
            this.departmentService.findAll().then((response) => {
                if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                    this.setState({departmentList: response});
                }
            });
        }
    }

    saveProduct = async () => {
        let product = this.state.product;
        const selectedTax = this.state.taxList.find(t => t.rate === product.taxRate);

        const data = {
            name: product.itemName,
            barcode: product.barcode,
            tax: selectedTax ? selectedTax.id : null,
            weighable: product.weighable,
            profitMargin: product.profitMargin ?? await this.getDefaultProfitMargin(),
            quantity: product.itemSize,
            price: product.salePrice,
            unit: product.itemUnitMeasure,
            boxUnit: product.boxUnitMeasure,
            minStock: product.minStock,
            maxStock: product.maxStock,
            departmentId: product.departmentId,
            productType: 'PRODUCT_LINE',
            status: 'ACTIVE',
            boxQuantity: product.boxSize

        };


        return this.productService.create(data) // return eklendi
            .then((response) => {
                if (!GeneralUtils.isNullOrEmpty(response)) {
                    if (GeneralUtils.isNullOrEmpty(response.type)) {
                        let product = this.state.product;
                        product.itemBssId = response.bssId;
                        product.oldPrice = response.price;
                        product.currentBoxPrice = response.costPrice;
                        product.currentBoxSize = (response.boxQuantity != null && response.boxQuantity !== 0) ? response.boxQuantity : null;
                        this.setState({product});
                        return product;
                    } else {
                        toast.error("Error: " + response.type);
                        throw new Error(response.type);
                    }
                } else {
                    toast.error("Unknown error");
                    throw new Error("Unknown error");
                }
            })
            .catch((error) => {
                toast.error("Server Error: " + error.message);
                throw error;
            });
    };


    convertToDto = async (response) => {
        let product = this.state.product;
        product.itemName = response.name;
        product.itemBssId = response.bssId;
        product.barcode = response.barcode;
        product.itemSize = response.quantity;
        product.taxRate = (response.taxRate ?? response.departmentTaxRate);
        product.weighable = response.weighable;
        product.oldPrice = response.price;
        product.currentBoxPrice = response.costPrice;
        product.currentBoxSize = (response.boxQuantity != null && response.boxQuantity !== 0) ? response.boxQuantity : null;
        product.status = "ACTIVE";
        product.barcodeType = response.barcodeType;
        product.barcodeDigit = response.barcodeDigit;
        product.codeLength = response.codeLength;

        product.profitMargin = response.profitMargin ?? await this.getDefaultProfitMargin();
        product.itemUnitMeasure = response.unit;
        product.boxUnitMeasure = response.boxUnit;
        if (response.minStock != null && response.minStock !== 0) {
            product.minStock = response.minStock;
        } else {
            product.minStock = await this.getDefaultMinStock();
        }

        if (response.maxStock != null && response.maxStock !== 0) {
            product["maxStock"] = response.maxStock;
            product["maxOrjStock"] = response.maxStock;
        } else {
            const deliveryQuantity = product.deliveryQuantity || 0;
            const boxSize = product.boxSize || 0;
            product["maxStock"] = deliveryQuantity * boxSize;
            product["maxOrjStock"] = null;
        }


        product.departmentId = response.departmentId;
        product.barcodeIsSearched = true;
        product.newCodedProduct = false;

        this.stockActivityService.getCurrentStockOfProduct(response.bssId)
            .then((response) => {
                if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                    this.setState({
                        currentStock: response,

                    });
                }
            });

        this.setState({product: product});


    }

    __handleChangePrice = (e) => {
        const value = e.target.parsedValue !== undefined ? e.target.parsedValue : e.target.value;
        const product = {...this.state.product};

        // 👇 Sadece kullanıcı manuel girdiyse işlem yap
        if (e.isManual && e.target.name === "salePrice") {
            product[e.target.name] = value;
            product.tillPriceCalculationMethod = "MANUAL_ENTRY";
            const calculated = this.props.calculateFields(product);
            this.setState({product: calculated});
        } else {
            product[e.target.name] = value;
            this.setState({product});
        }

    };

    __handleChange = (e) => {
        let value = e.target.parsedValue !== undefined ? e.target.parsedValue : e.target.value;
        let name = e.target.name;

        // Barcode alanında sadece rakam kabul et
        if (name === "barcode" && value != null) {
            value = value.toString().replace(/[^0-9]/g, '');
        }
        if (name === "profitMargin" && value !== null && value !== undefined && value !== '') {
            value = parseInt(value, 10);
            if (Number.isNaN(value)) {
                value = '';
            }
        }

        let updatedProduct = {...this.state.product};
        updatedProduct[name] = value;
        if (name === "barcodeType" && (value == "WEIGHT" || value == "PRICE")) {
            updatedProduct.codeLength = 7;
            updatedProduct.barcodeDigit = 5;
        }
        // Barkod değiştiyse bazı alanları sıfırla
        if (name === "barcode") {
            updatedProduct.barcodeIsSearched = false;
            updatedProduct.itemBssId = null;
            updatedProduct.newCodedProduct = false;
        }

        if (name == "barcode" && value.length < 12) {
            updatedProduct.barcodeType = 'NORMAL'
            updatedProduct.barcodeDigit = null;
            updatedProduct.codeLength = null;
        }

        if (name === "deliveryQuantity" || name === "boxSize") {
            if (updatedProduct.maxOrjStock == null) {
                const deliveryQuantity = updatedProduct.deliveryQuantity || 0;
                const boxSize = updatedProduct.boxSize || 0;
                updatedProduct.maxStock = deliveryQuantity * boxSize;
            }
        }


        // DepartmentId değiştiyse ve itemBssId boşsa
        if (name === "departmentId" && GeneralUtils.isNullOrEmpty(updatedProduct.itemBssId)) {
            const selectedDepartment = this.state.departmentList.find(d => d.id == value);

            if (selectedDepartment) {
                if (selectedDepartment.profitMargin != null) {
                    updatedProduct.profitMargin = selectedDepartment.profitMargin;
                }

                if (selectedDepartment.taxRate != null) {
                    const selectedTax = this.state.taxList.find(t => t.rate === selectedDepartment.taxRate);
                    if (selectedTax) {
                        updatedProduct.taxRate = selectedTax.rate;
                    }
                }
            }
        }

        const runFindByBarcode = name === "barcode" && value && value.toString().length === 13;
        this.setState(prevState => {
            const calculated = this.props.calculateFields(updatedProduct, name);
            return {product: calculated};
        }, () => {
            if (runFindByBarcode && this.state.product.barcode && this.state.product.barcode.toString().length === 13) {
                this.findByBarcode();
            }
        });


    };

    handleBarcodeSearchClick = () => {
        let product = {...this.state.product};
        this.setState({product}, () => this.findByBarcode());
    };


    generateNextBarcode = () => {
        this.productService.getNextBarcode().then(response => {
            if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                let product = this.state.product;
                product["barcode"] = response.barcode;
                this.setState({product: product});
            }

        });
    }
    getDefaultProfitMargin = () => {
        return this.merchantBranchSettingsService
            .findByBranchId(localStorage.getItem("merchantBranchId"))
            .then((response) => {
                if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                    return response.profitMargin?? 40;
                }
                return 40;
            });
    };
    getDefaultMinStock = () => {
        return this.merchantBranchSettingsService
            .findByBranchId(localStorage.getItem("merchantBranchId"))
            .then((response) => {
                if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                    return response.minStock ?? null; // response.minStock varsa al, yoksa null
                }
                return null;
            });
    };

    getDefaultData = () => {
        this.merchantBranchSettingsService.findByBranchId(localStorage.getItem("merchantBranchId"))
            .then(async (response) => {
                if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                    let product = this.state.product;
                    if (response.minStock != null) {
                        product["minStock"] = response.minStock;
                    } else {
                        product["minStock"] = null;
                    }

                    if (product.departmentId == null && response.departmentId != null) {
                        product["departmentId"] = response.departmentId;
                    }

                    const deliveryQuantity = product.deliveryQuantity || 0;
                    const boxSize = product.boxSize || 0;
                    product["maxStock"] = deliveryQuantity * boxSize;

                    this.setState({product: product});
                }
            });

    }
    toggleProduct = () => {
        this.setState(prevState => ({
            productOpen: !prevState.productOpen,
            costPricingOpen: false,
            othersOpen: false
        }));
    };

    toggleCostPricing = () => {
        this.setState(prevState => ({
            costPricingOpen: !prevState.costPricingOpen,
            productOpen: false,
            othersOpen: false
        }));
    };

    toggleOthers = () => {
        this.setState(prevState => ({
            othersOpen: !prevState.othersOpen,
            productOpen: false,
            costPricingOpen: false
        }));
    };


}

PurchaseOrderItemMobileSave.propTypes = {
    order: PropTypes.object
};
